import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { FaFileInvoiceDollar } from 'react-icons/fa';
import axios from 'axios';
import Header from '../components/Header';
import Footer from '../components/Footer';

const API_URL = 'https://api.marketmaestroovip.in';

const RefundPolicy = () => {
  const [data, setData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

     // Scroll to top when page loads
    useEffect(() => {
      window.scrollTo(0, 0);
    }, []);

  useEffect(() => {
    const fetchPolicy = async () => {
      try {
        setIsLoading(true);
        const res = await axios.get(`${API_URL}/api/policies`);
        setData(res.data.data || {});
      } catch (err) {
        console.error('Error fetching refund policy:', err);
        setData({});
      } finally {
        setIsLoading(false);
      }
    };
    fetchPolicy();
  }, []);

  const title = data?.refund_title || 'Refund Policy';
  const lastUpdated = data?.refund_last_updated || '';
  const content = data?.refund_content || '';

  return (
    <>
      <Header />

      {/* Page Header */}
      <div className="bg-gradient-to-r from-blue-600 to-blue-700 text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
          <div className="flex items-center gap-3 mb-2">
            <FaFileInvoiceDollar className="text-2xl" />
            <h1 className="text-3xl md:text-4xl font-bold">{title}</h1>
          </div>
          {lastUpdated && (
            <p className="text-blue-100">Last Updated: {lastUpdated}</p>
          )}
          <p className="text-blue-200 text-sm mt-1">
            SEBI Registered Research Analyst (INH000021757)
          </p>
        </div>
      </div>

      {/* Content */}
      <section className="min-h-screen py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="bg-white rounded-2xl shadow-lg p-8 md:p-10"
          >
            {isLoading ? (
              <div className="flex justify-center items-center py-20">
                <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
              </div>
            ) : content.trim() ? (
              <div className="whitespace-pre-wrap text-gray-700 leading-relaxed text-[15px]">
                {content}
              </div>
            ) : (
              <p className="text-gray-500 italic text-center py-10">
                Content will be added soon.
              </p>
            )}
          </motion.div>
        </div>
      </section>

      <Footer />
    </>
  );
};

export default RefundPolicy;